'use strict';

module.exports = Object.prototype.toString;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/var/internalToString.js
// module id = 845
// module chunks = 0